// REACT IMPORTS

// ICONS IMPORTS
import { FailedAgreementIcon } from "icons/action/FailedIcon";
import { CloseIcon } from "icons/payments/CloseIcon";
import { useNavigate } from "react-router-dom";

// PROPS TYPES
interface FailedScreenProps {
  onCloseClick: any;
  title: string;
  content: any;
  clusterId?: string;
}

/* ------------------------------------- SUCCESS SCREEN ------------------------------------- */

const FailedScreen = (props: FailedScreenProps) => {
  const { onCloseClick, title, content, clusterId } = props;
  const navigate = useNavigate();

  return (
    <div className="bg-bgPrimary h-full animate__animated animate__fadeIn">
      <div className="px-10 py-5 bg-bgPrimary flex items-center justify-end">
        <div
          onClick={onCloseClick}
          className="cursor-pointer p-2 rounded-full hover:!bg-bgSecondary"
        >
          <CloseIcon />
        </div>
      </div>
      <div className="px-[45px] flex flex-col items-center justify-center gap-10 h-[calc(var(--shell-vh)-58px)]">
        <FailedAgreementIcon />
        <div className="flex flex-col items-center gap-4">
          <p className="text-center text-txtPrimary font-medium text-2xl leading-normal">
            {title}
          </p>
          <p className="text-center text-txtParagraph text-base leading-normal break-words">
            {content}
          </p>
        </div>
        <div className="w-full lg:text-base text-sm text-center text-btnPrimaryActive hover:!text-btnPrimaryHover ">
          <div
            className="cursor-pointer"
            onClick={() => navigate(`/${clusterId}/dashboard`)}
          >
            Back to dashboard
          </div>
        </div>
      </div>
    </div>
  );
};

export default FailedScreen;
